import React from 'react'
import PointBar from '../PointBar'
import { getPercent } from '@utils'
import './index.scss'

import pointDefault from '@img/mkt/pointDefault.png'
interface IProps {
  data: IPointCard;
  onClick?: (e: any) => void;
}

const pointCard: React.FC<IProps> = ({ data, onClick }) => {
  const getStatus = () => {
    if (data.extra?.participateNum && parseInt(data.partTakeNum) >= parseInt(data.extra?.participateNum)) {
      return i18n.t('mkt.market.hasReachedTheLimit')
    } else if (data.points >= data.collectPointTarget) {
      return i18n.t('mkt.market.haveRewards')
    } else {
      return ''
    }
  }
  return (
    <div
      data-cypid='mmgToPointCard'
      className={`point-card${data.extra?.bgType === 'img' ? ' point-card-height' : ''}`} onClick={onClick} style={data.extra?.bgType === 'img' ? {
        backgroundImage: `Url(${data.extra.bgImg || pointDefault})`,
        color: data.extra.fontColor || '#161616'
      } : {
        backgroundColor: data.extra.bgColor || '#ffffff',
        color: data.extra.fontColor || '#161616'
      }}
    >
      <div className='point-con'>
        <div className='point-con-top'>
          {
            data.extra.showTitle !== false
              ? (
                <>
                  <div className='point-card-title'>
                    <div className='name'>{data.activityName}</div>
                    {getStatus() && data.extra?.bgType === 'img' && <div className='status'>{getStatus()}</div>}
                  </div>
                  {
                    data.extra?.bgType === 'img' || !getStatus() ? (
                      <div className='right'>
                        {data.points >= data.collectPointTarget
                          ? data.collectPointTarget
                          : data.points}/{data.collectPointTarget}
                      </div>
                    ) : (
                      <div className='right-status'>{getStatus()}</div>
                    )
                  }
                </>
              ) : ''
          }
        </div>
        <div className='point-list'>
          {
            data.extra.showProgress !== false &&
              <>
                {
                  data.extra.progressType === 'bar' ? (
                    <>
                      <PointBar
                        color={data.extra.progressBarColor}
                        bgColor={data.extra.progressBarBgColor}
                        rate={getPercent(data.points >= data.collectPointTarget
                          ? data.collectPointTarget
                          : data.points, data.collectPointTarget)}
                      >
                      </PointBar>
                    </>
                  ) : (
                    <>
                      {[
                        ...Array(data.collectPointTarget > 8 ? 7 : data.collectPointTarget),
                      ].map((item: any, index: number) => {
                        return (
                          <div
                            className='point-item'
                            style={{
                              backgroundImage:
                              index < data.points
                                ? `Url(${data.extra?.iconEnable || '/resources/images/collectPoint/cup.png'})`
                                : `Url(${data.extra?.iconDisable || '/resources/images/collectPoint/cup-disable.png'})`,
                            }}
                            key={index}
                          >
                          </div>
                        )
                      })}
                      {
                        data.collectPointTarget > 8 ? (
                          <div
                            className='point-item'
                          >
                            <i className='iconfont icon-ellipsis'></i>
                          </div>) : [
                          ...Array(8 - data.collectPointTarget),
                        ].map((item: any, index: number) => {
                          return (
                            <div
                              className='point-item'
                              key={index}
                            >
                            </div>
                          )
                        })
                      }
                    </>
                  )
                }
              </>
          }
        </div>
      </div>
    </div>
  )
}

export default pointCard
